/* Nextkans – interactie voor header, sliders en productkaarten */
(function () {
  if (window.__nextkansInit) return;
  window.__nextkansInit = true;

  const routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Melding ---------- */
  let toastTimer;
  function toast(html) {
    let el = document.querySelector('.nk-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'nk-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = html;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 3500);
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-nk-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  /* ---------- Klikacties ---------- */
  document.addEventListener('click', (event) => {
    const target = event.target;

    // Mobiel menu
    const menuOpen = target.closest('[data-nk-menu-open]');
    if (menuOpen) {
      const drawer = document.getElementById('nk-drawer');
      if (drawer) {
        drawer.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        drawer.querySelector('[data-nk-menu-close]')?.focus();
      }
      return;
    }
    if (target.closest('[data-nk-menu-close]')) {
      const drawer = document.getElementById('nk-drawer');
      if (drawer) {
        drawer.hidden = true;
        document.documentElement.style.overflow = '';
      }
      return;
    }

    // Alle categorieën
    const allcats = target.closest('[data-nk-allcats-toggle]');
    if (allcats) {
      const panel = document.getElementById(allcats.getAttribute('aria-controls'));
      if (panel) {
        const open = panel.hidden;
        panel.hidden = !open;
        allcats.setAttribute('aria-expanded', String(open));
      }
      return;
    }
    document.querySelectorAll('[data-nk-allcats-toggle][aria-expanded="true"]').forEach((btn) => {
      if (!btn.parentElement.contains(target)) {
        btn.setAttribute('aria-expanded', 'false');
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
      }
    });

    // Winkelwagen-knop: open de drawer van het thema als die er is
    const cartBtn = target.closest('[data-nk-cart-open]');
    if (cartBtn) {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        event.preventDefault();
        drawer.open();
      }
      return;
    }

    // Aantal +/-
    const step = target.closest('[data-nk-qty-step]');
    if (step) {
      const wrap = step.closest('.nk-qty');
      const input = wrap.querySelector('input');
      const next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.nkQtyStep));
      input.value = next;
      wrap.querySelector('[data-nk-qty-step="-1"]').disabled = next <= 1;
      return;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const drawer = document.getElementById('nk-drawer');
    if (drawer && !drawer.hidden) {
      drawer.hidden = true;
      document.documentElement.style.overflow = '';
    }
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.nk-qty input');
    if (!input) return;
    const value = Math.max(1, parseInt(input.value, 10) || 1);
    input.value = value;
    input.closest('.nk-qty').querySelector('[data-nk-qty-step="-1"]').disabled = value <= 1;
  });

  /* ---------- In winkelwagen (AJAX) ---------- */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-nk-add-form]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const card = form.closest('.nk-card');
    const qtyInput = card ? card.querySelector('.nk-qty input') : null;
    const quantity = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
    const id = form.querySelector('input[name="id"]').value;
    const hasDrawer = !!document.getElementById('shopify-section-cart-drawer-section');

    button.classList.add('is-loading');
    button.disabled = true;

    try {
      const response = await fetch(routes + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity }],
          sections: hasDrawer ? 'cart-drawer-section' : undefined,
        }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Toevoegen mislukt');

      const cart = await fetch(routes + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      setCartCount(cart.item_count);

      // Op de winkelwagenpagina (zonder drawer) de pagina verversen, zodat regels en totalen kloppen
      if (!hasDrawer && document.querySelector('.cart-page')) {
        window.location.reload();
        return;
      }

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 1500);

      const drawerHtml = data.sections && data.sections['cart-drawer-section'];
      const drawerSection = document.getElementById('shopify-section-cart-drawer-section');
      if (drawerHtml && drawerSection) {
        const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const fresh = doc.getElementById('shopify-section-cart-drawer-section');
        drawerSection.innerHTML = fresh ? fresh.innerHTML : drawerHtml;
        const drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          requestAnimationFrame(() => drawer.open());
          return;
        }
      }
      toast('Toegevoegd aan je winkelwagen. <a href="' + routes + 'cart">Bekijk winkelwagen</a>');
    } catch (error) {
      button.classList.remove('is-loading');
      toast(error.message || 'Er ging iets mis, probeer het opnieuw.');
    } finally {
      button.disabled = false;
    }
  });

  /* ---------- Winkelwagen: 'Maak je bestelling compleet' ---------- */
  // Haalt via Shopify-productaanbevelingen maximaal 3 beschikbare producten op die nog niet in de
  // winkelwagen zitten (sections/nk-cart-upsell.liquid). Zonder resultaat blijft het blok verborgen.
  if (!customElements.get('nk-cart-upsell')) {
    class NkCartUpsell extends HTMLElement {
      connectedCallback() {
        this.handleCartChange = () => {
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.load(true), 250);
        };
        document.addEventListener('shopify:cart:lines-update', this.handleCartChange);
        this.load(false);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:cart:lines-update', this.handleCartChange);
        clearTimeout(this.refreshTimer);
        this.controller?.abort();
      }

      async load(fromCart) {
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;

        try {
          let productId = this.dataset.productId;
          if (fromCart) {
            const cart = await fetch(routes + 'cart.js', {
              headers: { Accept: 'application/json' },
              signal: controller.signal,
            }).then((r) => r.json());
            if (!cart.items || !cart.items.length) {
              this.clear();
              return;
            }
            productId = String(cart.items[0].product_id);
          }
          if (!productId || !this.dataset.baseUrl) {
            this.clear();
            return;
          }

          const url = new URL(this.dataset.baseUrl, window.location.origin);
          url.searchParams.set('product_id', productId);
          url.searchParams.set('limit', '10');
          url.searchParams.set('intent', 'related');
          url.searchParams.set('section_id', 'nk-cart-upsell');

          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Aanbevelingen niet beschikbaar');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = doc.querySelector('.nk-upsell');
          if (controller !== this.controller) return;

          if (content) {
            this.replaceChildren(document.importNode(content, true));
            this.hidden = false;
          } else {
            this.clear();
          }
        } catch (error) {
          if (error.name !== 'AbortError') this.clear();
        }
      }

      clear() {
        this.replaceChildren();
        this.hidden = true;
      }
    }
    customElements.define('nk-cart-upsell', NkCartUpsell);
  }

  /* ---------- USP-balk ---------- */
  function initUsp(root) {
    const slides = root.querySelector('.nk-usp__slides');
    if (!slides || slides.dataset.nkReady) return;
    slides.dataset.nkReady = '1';
    const count = slides.children.length;
    if (count < 2) return;
    let index = 0;
    setInterval(() => {
      const perView = window.matchMedia('(min-width: 768px)').matches ? 2 : 1;
      const max = Math.max(0, count - perView);
      index = index >= max ? 0 : index + 1;
      slides.style.transform = 'translateX(-' + (index * 100) / perView + '%)';
    }, 4000);
  }

  /* ---------- Hero-slider ---------- */
  function initHero(root) {
    const track = root.querySelector('.nk-hero__slides');
    if (!track || track.dataset.nkReady) return;
    track.dataset.nkReady = '1';
    const slides = Array.from(track.children);
    const dots = Array.from(root.querySelectorAll('.nk-hero__dots button'));
    if (slides.length < 2) return;

    const current = () => Math.round(track.scrollLeft / track.clientWidth);
    const go = (i) => {
      const n = (i + slides.length) % slides.length;
      track.scrollTo({ left: n * track.clientWidth });
    };
    const sync = () => {
      const i = current();
      dots.forEach((d, n) => d.setAttribute('aria-current', String(n === i)));
    };

    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
    root.querySelector('.nk-hero__arrow--prev')?.addEventListener('click', () => go(current() - 1));
    root.querySelector('.nk-hero__arrow--next')?.addEventListener('click', () => go(current() + 1));

    const delay = Number(root.dataset.autoplay || 0) * 1000;
    if (delay > 0 && !window.Shopify?.designMode) {
      let paused = false;
      root.addEventListener('mouseenter', () => (paused = true));
      root.addEventListener('mouseleave', () => (paused = false));
      setInterval(() => {
        if (!paused) go(current() + 1);
      }, delay);
    }
  }

  function initAll() {
    document.querySelectorAll('.nk-usp').forEach(initUsp);
    document.querySelectorAll('.nk-hero').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
